@if (projectService.loading) {
  <div class="d-flex align-items-center justify-content-center" style="height: 50vh;">
    <app-loading-spinner></app-loading-spinner>
  </div>
}
@if (projects.length > 0  && !projectService.loading) {
  <div class="chat-wrapper d-lg-flex gap-1 mx-n4 mt-n4 p-1" role="none">
    @if (!conversationPage) {
      <app-project-sidebar [ngClass]="isShowMenu ? 'menubar-show' : ''" class="file-manager-sidebar" id="menusidebar" [projects]="projects" [plan_usage]="projectService.plan_usage" (showSidebarEvent)="toggleSidebar($event)"></app-project-sidebar>
    }
    <div class="file-manager-content w-100 p-3 py-0">
      <router-outlet></router-outlet>
    </div>
  </div>
}
@if (projects.length === 0 && !projectService.loading) {
  <div class="d-flex align-items-center justify-content-center" style="height: 50vh;">
    @if (currentClient.plan) {
      <div class="text-center">
        <h1 class="text-warning">You are not assign to any project!</h1>
        <p class="text-muted">Contact your admin to assign you to a project or more.</p>
      </div>
    }
    @if (!currentClient.plan) {
      <div class="text-center">
        <h1 class="text-warning">No Subscription Found!</h1>
        <p class="text-muted">You must have an active subscription to see this page.</p>
      </div>
    }
  </div>
}